import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import "../../../styles/principals/blog/blog.css";
import axios from 'axios';

const Blog = () => {
  const [blogEntries, setBlogEntries] = useState([]);
  const navigate = useNavigate();
  
  const getBlogEntries = () => {
    const url = `${process.env.REACT_APP_API_URL}/blog/getEntries`;
    console.log("URL Blog: " + url);
  
    axios.get(url, { withCredentials: true })
      .then(response => {
        setBlogEntries(response.data);
      })
      .catch(error => {
        console.error("Error al obtener entradas del blog:", error);
      });
  };
  

  useEffect(() => {
    console.log("useEffect");
    getBlogEntries();
  }, []);

  // Función para convertir la fecha de "dd/mm/yyyy" a un formato reconocible por JavaScript
  const convertDate = (dateString) => {
    const [day, month, year] = dateString.split('-');
    return new Date(year, month - 1, day); // Meses en JavaScript comienzan desde 0
  };

  // Ordenar las entradas del blog por fecha de forma descendente (más reciente primero)
  const sortedEntries = [...blogEntries].sort((a, b) => convertDate(b.date) - convertDate(a.date));

  const handleReadMore = (id) => {
    navigate(`/blog/${id}`); // Navega al componente BlogArticle con el ID del artículo
  };

  return (
    <div className="blog-container">
      {/* <h1 className="center">El Blog de NOI</h1> */}
      <div className="blog-articles">
         {/* <h2>Todos los artículos</h2> */}
        {sortedEntries.map((entry) => (
          <div className="blog-entry" key={entry.id}>
            <img src={entry.short_img} alt="Foto del artículo" clasname="article-image"/>
            <div className="article-text">
              <div className="blog-entry-description">
                <p>{entry.author}</p>&nbsp; &#8226; &nbsp;<p>{entry.date}</p>
              </div>
              <div className="blog-content">
                <h3>{entry.title}</h3>
                <p>{entry.short_content}</p>
                <div className="tags">
                  {entry.tagNames.split(',').map((tag, index) => {
                    const tagColor = entry.tagColors.split(',')[index];
                    return (
                      <p key={index} className={`article-tag ${tagColor ? tagColor : ''}`}>
                        {tag.trim()}
                      </p>
                    );
                  })}
                  <button className="read-all" onClick={() => handleReadMore(entry.id)}>Leer todo</button>

                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
